import { render } from "./Home.vue?vue&type=template&id=5ea9d81d"
const script = {}
script.render = render

export default script